import Footer from "../Components/Footer"
import Header from "../Components/Header"
import Plans from "../Components/Payment/Plans"

const Payment = () => {
  return (
    <div>
      <Header />
        <Plans/>
      <Footer p="5rem 9.6rem 0 9.6rem"/>
    </div>
  )
}

export default Payment
